import { render, staticRenderFns } from "./AnalysisPage.vue?vue&type=template&id=08b04615&scoped=true"
import script from "./AnalysisPage.vue?vue&type=script&lang=js"
export * from "./AnalysisPage.vue?vue&type=script&lang=js"
import style0 from "./AnalysisPage.vue?vue&type=style&index=0&id=08b04615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b04615",
  null
  
)

export default component.exports